import { NavItemType } from 'types';
import adminPanel from './adminPanel';

// ==============================|| MENU ITEMS ||============================== //

const menuItems: { items: NavItemType[] } = {
  items: [adminPanel]
};

export default menuItems;
